<template>
  <div class="myContentHead">
    <div class="header">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <div class="middle">
        <slot name="middle"></slot>
      </div>
      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "myContentHead"
};
</script>
<style lang="scss" scoped>
.myContentHead {
  .header {
    width: 100%;
    height: $top-height;
    margin-bottom: $top;
    margin-top:$top;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // .ivu-input-wrapper {
    //   margin-right: $left;
    // }
    /deep/ .ivu-icon {
      font-size: 16px;
    }
  }
  .left {
    .left-content{
      height: 100%;
      display: flex;
      align-items: center;
    }
    // flex: 1;
  }
  .middle{
    // flex: 1;
  }
  .right {
    // flex: 1;
    text-align: right;
    &>div{
      display: flex;
      flex-wrap: nowrap;
      .ivu-btn{
        margin-left: $left;
      }
    }
  }
  .ivu-btn-large{
      margin-left: $left;
    }
  .left-content {
    display: flex;
    flex-wrap: nowrap;
    &>div:not(:first-child){
      margin-left: $left;
    }
    
    // .ivu-select-large,.ivu-cascader,.ivu-date-picker,.ivu-input-wrapper{
    //   margin-left: $left;
    // }
  }
}
</style>
